import React from 'react';
import PropTypes from 'prop-types';

import { TextStyled } from './styles';

export function TextCardSplitDash(props) {
	const { size, weight, color, center, className, children } = props;
	return (
		<TextStyled
			className={className}
			size={size}
			color={color}
			weight={weight}
			center={center}>
			{children}
		</TextStyled>
	);
}

Text.propTypes = {
	size: PropTypes.string,
	className: PropTypes.string,
	color: PropTypes.string,
	weight: PropTypes.string,
	center: PropTypes.bool,
	children: PropTypes.oneOfType([PropTypes.any]),
};

Text.defaultProps = {
	size: 'default',
	color: 'default',
	weight: 'default',
	center: false,
	className: '',
	children: undefined,
};
